// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3756":"b268d8d4","5205":"9cb2ae18"}[chunkId] + ".chunk.css";
};